import React from 'react';
import { Alert, Button, Typography } from '@mui/material';

function formatRefreshedAt(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString();
}

/**
 * Prominent snapshot freshness notice for teacher + supervisor monthly achievement views.
 * @param {'teacher'|'supervisor'} variant
 */
export function MonthlyReportSnapshotFreshnessAlert({
  generatedAt,
  snapshotStale = false,
  status,
  variant = 'teacher',
  onRefresh,
  refreshDisabled = false,
}) {
  const when = formatRefreshedAt(generatedAt);
  if (!when) return null;

  const isDraftLike = ['draft', 'rejected'].includes(status);
  const severity = snapshotStale ? 'warning' : 'info';
  const whoRefresh =
    variant === 'supervisor'
      ? 'Ask the teacher to use Refresh from sessions (while the report is still a draft or returned).'
      : 'Use Refresh from sessions to pull the latest attendance, class notes, and modules.';

  return (
    <Alert
      severity={severity}
      sx={{ mb: 2 }}
      action={
        variant === 'teacher' && isDraftLike && onRefresh ? (
          <Button color="inherit" size="small" disabled={refreshDisabled} onClick={onRefresh}>
            Refresh now
          </Button>
        ) : null
      }
    >
      <Typography fontWeight={700} sx={{ mb: 0.5 }}>
        {snapshotStale ? 'Snapshot out of date' : 'Report snapshot'}
      </Typography>
      <Typography variant="body2">
        Data shown is from <strong>{when}</strong>
        {snapshotStale
          ? ' — newer class logs or session updates exist.'
          : ' (frozen until refreshed).'}{' '}
        {whoRefresh}
      </Typography>
    </Alert>
  );
}
